export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.21-1406.58",
  commitId: "f5e9f6487b51dd95b3488aa6079a9ae0085f36b2",
  commitTime: "2026-10-21T14:06:58.000Z",
});
